(function () {
  const header = () => {
    const header = document.querySelector(".shopify-section-header");
    const menu = document.querySelector(".list-menu--inline");
    const menuLinks = document.querySelectorAll(".list-menu-item");
    const search = document.querySelector(".header__search");

    if (!header || !menu) return;

    let hideMenuTimeout;

    header.addEventListener("keydown", (e) => {
      if (e.code === "Escape" && search.isOpen) {
        search.close();
      }
    });

    const annBar = document.querySelector(".section-announcement");
    const annBarObserver = new IntersectionObserver((entries) => {
      const [entry] = entries;

      if (entry.isIntersecting) {
        document.documentElement.style.setProperty(
          "--ann-height",
          `${entry.intersectionRect.height}px`
        );
      } else {
        document.documentElement.style.setProperty("--ann-height", `0px`);
      }
    });
    if (annBar) annBarObserver.observe(annBar);

    const megaMenus = document.querySelectorAll(".mega-menu");
    const headerMain = header?.querySelector(".header");
    let megaMenuResizeObserver = null;
    let activeMegaMenu = null;

    const resetMegaMenuSize = (megaMenu) => {
      megaMenu.style.width = "";
      megaMenu.style.maxWidth = "";
      megaMenu.style.right = "";
    };

    const hideMegaMenu = (megaMenu) => {
      resetMegaMenuSize(megaMenu);
      megaMenu.style.opacity = "0";
      megaMenu.style.display = "none";
    };

    const calcMegaMenuPosition = (megaMenu) => {
      if (!headerMain || !megaMenu) return;

      resetMegaMenuSize(megaMenu);
      megaMenu.style.right = "auto";

      if (megaMenu.classList.contains("mega-menu--tabs")) {
        const activeTab = megaMenu.querySelector(
          ".mega-menu__tab-wrapper--active"
        );
        const activeList = activeTab?.querySelector(".mega-menu__tab-list");
        const headerRect = headerMain.getBoundingClientRect();
        const maxAllowed = Math.min(
          headerRect.width - 40,
          window.innerWidth - 40
        );
        const menuRect = megaMenu.getBoundingClientRect();
        const menuWidth = menuRect.width;

        let contentRight = menuRect.left + menuWidth;

        if (activeTab) {
          contentRight = Math.max(
            contentRight,
            activeTab.getBoundingClientRect().right
          );
        }

        if (activeList) {
          contentRight = Math.max(
            contentRight,
            activeList.getBoundingClientRect().right
          );
        }

        const neededWidth = Math.ceil(contentRight - menuRect.left + 16);

        if (neededWidth > menuWidth && neededWidth <= maxAllowed) {
          megaMenu.style.width = `${neededWidth}px`;
          megaMenu.style.maxWidth = `${neededWidth}px`;
        }
      }

      const megaMenuRight = megaMenu.getBoundingClientRect().right;
      const headerRight = headerMain.getBoundingClientRect().right;

      if (megaMenuRight > headerRight) {
        megaMenu.style.right = "2rem";
      }
    };

    const showMegaMenu = (megaMenu) => {
      if (!megaMenu) return;

      megaMenus.forEach((menu) => {
        if (menu !== megaMenu) {
          hideMegaMenu(menu);
        }
      });

      activeMegaMenu = megaMenu;
      megaMenu.style.opacity = "0";
      megaMenu.style.display = "grid";

      requestAnimationFrame(() => {
        calcMegaMenuPosition(megaMenu);
        megaMenu.style.opacity = "1";
      });
    };

    if (headerMain && !megaMenuResizeObserver) {
      let headerMainWidth = headerMain.offsetWidth;

      megaMenuResizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
          const newWidth = entry.contentRect.width;

          if (newWidth !== headerMainWidth) {
            headerMainWidth = newWidth;

            if (activeMegaMenu) {
              calcMegaMenuPosition(activeMegaMenu);
            }
          }
        }
      });

      megaMenuResizeObserver.observe(headerMain);
    }

    menuLinks.forEach((link) => {
      link.addEventListener("mouseenter", (e) => {
        clearTimeout(hideMenuTimeout);

        if (link.classList.contains("list-menu--megamenu")) {
          link.classList.add("list-menu--megamenu-visible");

          if (!megaMenus.length) return;

          showMegaMenu(link.querySelector(".mega-menu"));

          menuLinks.forEach((el) => {
            if (el !== link) {
              el.classList.remove("list-menu--megamenu-visible");
            }
          });
        } else {
          menuLinks.forEach((el) => {
            el.classList.remove("list-menu--megamenu-visible");
          });
        }
      });
      link.addEventListener("mouseleave", (e) => {
        if (link.classList.contains("list-menu--megamenu")) {
          if (!megaMenus.length) return;
          const megaMenu = link.querySelector(".mega-menu");
          if (!megaMenu) return;

          megaMenu.style.opacity = "0";
          hideMenuTimeout = setTimeout(() => {
            if (activeMegaMenu === megaMenu) {
              activeMegaMenu = null;
            }
            hideMegaMenu(megaMenu);
          }, 100);
        }
      });
      link.addEventListener("focus", (e) => {
        if (link.classList.contains("list-menu--megamenu")) {
          link.classList.add("list-menu--megamenu-visible");

          showMegaMenu(link.querySelector(".mega-menu"));

          menuLinks.forEach((el) => {
            if (el !== link) {
              el.classList.remove("list-menu--megamenu-visible");
            }
          });
        } else {
          menuLinks.forEach((el) => {
            el.classList.remove("list-menu--megamenu-visible");
          });
        }
      });
    });
    menu.addEventListener("mouseleave", (e) => {
      if (!megaMenus.length) return;
      setTimeout(() => {
        activeMegaMenu = null;
        megaMenus.forEach((megaMenu) => {
          hideMegaMenu(megaMenu);
        });
      }, 100);
      menuLinks.forEach((link) => {
        link.classList.remove("list-menu--megamenu-visible");
      });
    });
    menu.addEventListener("focusout", (e) => {
      if (!megaMenus.length) return;
      setTimeout(() => {
        megaMenus.forEach((megaMenu) => {
          resetMegaMenuSize(megaMenu);
        });
      }, 500);
      menuLinks.forEach((link) => {
        link.classList.remove("list-menu--megamenu-visible");
      });
    });

    const megaMenuTabs = () => {
      $(".mega-menu__tab-wrapper")
        .children()
        .find(".mega-menu__tab-wrapper")
        .first()
        .addClass("mega-menu__tab-wrapper--active");

      const onTabActivate = (tabWrapper) => {
        const megaMenu = tabWrapper.closest(".mega-menu");
        if (megaMenu && megaMenu === activeMegaMenu) {
          requestAnimationFrame(() => calcMegaMenuPosition(megaMenu));
        }
      };

      $(".mega-menu__tab-wrapper").mouseenter(function () {
        $(".mega-menu__tab-wrapper").removeClass(
          "mega-menu__tab-wrapper--active"
        );
        $(this).addClass("mega-menu__tab-wrapper--active");
        onTabActivate(this);
      });
      $(".mega-menu__tab-wrapper").focus(function () {
        $(".mega-menu__tab-wrapper").removeClass(
          "mega-menu__tab-wrapper--active"
        );
        $(this).addClass("mega-menu__tab-wrapper--active");
        onTabActivate(this);
      });
      $(".mega-menu__tab-wrapper").focusin(function () {
        $(".mega-menu__tab-wrapper").removeClass(
          "mega-menu__tab-wrapper--active"
        );
        $(this).addClass("mega-menu__tab-wrapper--active");
        onTabActivate(this);
      });
    };
    megaMenuTabs();

    const main = document.querySelector("main");
    const breadcrumbs = document.querySelector(".breadcrumbs-wrapper");
    if (
      main.querySelectorAll(".shopify-section")[0] &&
      main
        .querySelectorAll(".shopify-section")[0]
        .classList.contains("section--has-overlay")
    ) {
    }

    const menuCloseBtn = document.querySelector(".header__modal-close-button");
    const mobileMenuDrawer = document.querySelector("header-drawer");
    if (menuCloseBtn && mobileMenuDrawer) {
      menuCloseBtn.addEventListener("click", (e) => {
        mobileMenuDrawer.closeMenuDrawer(e);
      });
    }
  };
	   document.addEventListener("DOMContentLoaded", () => {
        const headerIcons = document.querySelector(".header__icons");
      
        if (headerIcons && !document.querySelector('.request-pricing-wrapper')) {
          const requestPricingButton = document.createElement('div');
          requestPricingButton.className = 'request-pricing-wrapper topbar-wrapper__column';
          requestPricingButton.innerHTML = '<a href="/pages/contact-pravada" class="topbar-button" aria-label="Contact Pravada" rel="noopener">Contact Us</a>';
          headerIcons.insertAdjacentElement('afterbegin', requestPricingButton);
        }
      });
  document.addEventListener("shopify:section:load", header);
  document.addEventListener("shopify:section:unload", header);
  document.addEventListener("shopify:section:reorder", header);

  header();
})();
